import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gypsum-powder-page',
  templateUrl: './gypsum-powder-page.component.html',
  styleUrls: ['./gypsum-powder-page.component.scss']
})
export class GypsumPowderPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
